export class LinexoMountingError extends Error {
  constructor(appID: string) {
    super(`Couldn't mount Linexo Site Connect because no element with id ${appID} was found`)
  }
}
